import { Disclosure } from "@headlessui/react";

const Navbar = () => {
  return (
    <Disclosure as="nav" className="bg-white shadow-sm">
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex h-16 justify-between">
              <div className="flex">
                <div className="flex flex-shrink-0 items-center space-x-3">
                  <img
                    className="block h-8 w-auto rounded"
                    src="/img/logo.png"
                    alt="Logo"
                  />
                  <h3 className="text-xl font-semibold text-gray-800">
                    Casalucci s.r.l.
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Disclosure>
  );
};

export default Navbar;
